import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, HeaderFilter, FilterRow, FilterPanel, SearchPanel } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaListado } from "../../../Componentes/Compuestos/Paginas/PaginaListado";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";

export const CON_Reporte_IVAVentas = () => {
  const [data, setData] = useState([])
  const [dataTotalesTipo, setDataTotalesTipo] = useState([])
  const [dataTotalesCredito, setDataTotalesCredito] = useState([])
  const [dataTotalesDebito, setDataTotalesDebito] = useState([])
  const { CONT_Reportes: { function_CONT_Reportes_IVAVentas } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data.Detalle);
    setDataTotalesTipo(data.TotalesPorTipoDocumento);
    setDataTotalesDebito(data.TotalesDebito);
    setDataTotalesCredito(data.TotalesCredito);
  };

  return (
    <PaginaListado
      Titulo="I.V.A. VENTAS"
      funcion={function_CONT_Reportes_IVAVentas}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive d-flex justify-content-center" style={{ marginBottom: "20px" }}>
        {dataTotalesTipo.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={dataTotalesTipo}
            id="gridContainer"
            selectionMode="none"
          >
            <HeaderFilter visible={false} />
            <FilterPanel visible={false} />
            <FilterRow visible={false} />
            <SearchPanel visible={false} />

            <Summary>
              <TotalItem
                column="Id"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <TotalItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="IVA10"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="IVA21"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="IVA27"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="Impuestos"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />

              <TotalItem
                column="Total"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value}`} />
            </Summary>

            <Column caption="Tipo" dataField="Tipo" minWidth="50" width="100%" alignment="Left" dataType="string" allowSorting={false} />

            <Column caption="Importes" alignment="Center" >
              <Column caption="Neto" dataField="ImporteNeto" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 10.5 %" dataField="IVA10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 21 %" dataField="IVA21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 27 %" dataField="IVA27" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="Impuestos" dataField="Impuestos" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="TOTAL" dataField="Total" width="125" alignment="Right" dataType="number" format="currency" allowSorting={true} />
            </Column>

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>

      <div className="d-flex flex-wrap" style={{ gap: "10px", marginBottom: "20px" }}>
        {dataTotalesDebito.length > 0 ? (
          <div style={{ flex: 1, minWidth: "400px", maxWidth: "50%" }}>
            <LVGridCabeceraReporte
              dataSource={dataTotalesDebito}
              id="gridContainer"
              selectionMode="none"
            >
              <HeaderFilter visible={false} />
              <FilterPanel visible={false} />
              <FilterRow visible={false} />
              <SearchPanel visible={false} />

              <Summary>
                <TotalItem
                  column="Id"
                  summaryType="count"
                  customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoExento"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado10"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA10"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado21"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA21"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado27"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA27"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="Impuestos"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="Total"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />
              </Summary>

              <Column caption="Tipo" dataField="Tipo" minWidth="50" width="100%" alignment="Left" dataType="string" allowSorting={false} />

              <Column caption="Importes" alignment="Center" >
                <Column caption="Neto Exento" dataField="ImporteNetoExento" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 10.5 %" dataField="ImporteNetoGravado10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 10.5 %" dataField="IVA10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 21 %" dataField="ImporteNetoGravado21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 21 %" dataField="IVA21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 27 %" dataField="ImporteNetoGravado27" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 27 %" dataField="IVA27" width="90" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Impuestos" dataField="Impuestos" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="TOTAL" dataField="Total" width="110" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              </Column>

            </LVGridCabeceraReporte>
          </div>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos de Débito</h5>
          </div>
        )}
        {dataTotalesCredito.length > 0 ? (
          <div style={{ flex: 1, minWidth: "400px", maxWidth: "50%" }}>
            <LVGridCabeceraReporte
              dataSource={dataTotalesCredito}
              id="gridContainer"
              selectionMode="none"
            >
              <HeaderFilter visible={false} />
              <FilterPanel visible={false} />
              <FilterRow visible={false} />
              <SearchPanel visible={false} />

              <Summary>
                <TotalItem
                  column="Id"
                  summaryType="count"
                  customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoExento"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado10"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA10"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado21"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA21"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="ImporteNetoGravado27"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="IVA27"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="Impuestos"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />

                <TotalItem
                  column="Total"
                  summaryType="sum"
                  customizeText={summaryItem => `${summaryItem.value}`} />
              </Summary>

              <Column caption="Tipo" dataField="Tipo" minWidth="50" width="100%" alignment="Left" dataType="string" allowSorting={false} />

              <Column caption="Importes" alignment="Center" >
                <Column caption="Neto Exento" dataField="ImporteNetoExento" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 10.5 %" dataField="ImporteNetoGravado10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 10.5 %" dataField="IVA10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 21 %" dataField="ImporteNetoGravado21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 21 %" dataField="IVA21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Neto 27 %" dataField="ImporteNetoGravado27" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="IVA 27 %" dataField="IVA27" width="90" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="Impuestos" dataField="Impuestos" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                <Column caption="TOTAL" dataField="Total" width="110" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              </Column>

            </LVGridCabeceraReporte>
          </div>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos de Crédito</h5>
          </div>
        )}
      </div>

      <div className="table-responsive">
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
            selectionMode="none"
          >
            <HeaderFilter visible={false} />
            <FilterPanel visible={false} />
            <FilterRow visible={false} />
            <SearchPanel visible={false} />

            <Summary>
              <TotalItem
                column="Id"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <TotalItem
                column="ImporteNetoExento"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteNetoGravado10"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteIVA10"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteNetoGravado21"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteIVA21"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteNetoGravado27"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteIVA27"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />

              <TotalItem
                column="ImporteTotalPostImpuestos"
                summaryType="sum"
                customizeText={summaryItem => `${Math.round(summaryItem.value)}`} />
            </Summary>

            <Column caption="Fecha" dataField="FEFecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} allowSorting={false} />
            <Column caption="Tipo" dataField="VEN_DocsVenta_Tipos_Descripcion" width="150" alignment="Left" dataType="string" allowSorting={false} />
            <Column caption="Comprobante" dataField="FENumeroFantasia" width="120" alignment="Left" dataType="string" allowSorting={false} />
            <Column caption="Cliente" dataField="ABM_EEX_Clientes_RazonSocial" width="100%" minWidth="100" alignment="Left" dataType="string" allowSorting={false} />
            <Column caption="Provincia" dataField="ProvinciaVenta" width="100" alignment="Left" dataType="string" allowSorting={false} />
            <Column caption="C.U.I.T." dataField="CUIT" width="100" alignment="Left" dataType="string" allowSorting={false} />
            <Column caption="I.V.A." dataField="I_TipoIVA" width="70" alignment="Left" dataType="string" allowSorting={false} />

            <Column caption="Importes" alignment="Center" >
              <Column caption="Neto Exento" dataField="ImporteNetoExento" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="Neto 10.5 %" dataField="ImporteNetoGravado10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 10.5 %" dataField="ImporteIVA10" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="Neto 21 %" dataField="ImporteNetoGravado21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 21 %" dataField="ImporteIVA21" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="Neto 27 %" dataField="ImporteNetoGravado27" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="IVA 27 %" dataField="ImporteIVA27" width="100" alignment="Right" dataType="number" format="currency" allowSorting={true} />
              <Column caption="TOTAL" dataField="ImporteTotalPostImpuestos" width="110" alignment="Right" dataType="number" format="currency" allowSorting={true} />
            </Column>

          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
